import isEmpty from "is-empty";
import {
  Cart,
  CustomerBooking,
  Lineitem,
  Maybe,
  Service,
} from "rsl-api-106/lib/types";

import { TAXES_PRODUCTS } from "../constants";
import { ConfigMode } from "../contexts/ConfigContext";

//user normal
export const isUser = (authMode: number) => {
  return [0].includes(authMode);
};

//user CGOS/CNAS/MACIF (ayant droit authentifié)
export const isADA = (authMode: number) => {
  return [1].includes(authMode);
};

//partenaire
export const isPartner = (authMode: number) => {
  return [2].includes(authMode);
};

//ayant droit
export const isAD = (authMode: number) => {
  return [3, 5, 6].includes(authMode);
};

//propriétaire (pour le moment unis à terme dissociés)
export const isOwner = (authMode: number) => {
  return [4, 7, 10].includes(authMode);
};

// inscrivant et linéaire
export const isLinear = (authMode: number) => {
  return [8, 9].includes(authMode);
};

export const showCustomerInfoPopup = (user: Service) => {
  let bool = false;
  if (user) {
    if (isEmpty(user.lastName)) {
      bool = true;
    }
    if (isEmpty(user.firstName)) {
      bool = true;
    }
    if (isEmpty(user.birthDate)) {
      bool = true;
    }
    if (isEmpty(user.address?.mail)) {
      bool = true;
    }
    if (
      isEmpty(user.address?.city) ||
      isEmpty(user.address?.country) ||
      isEmpty(user.address?.streetName)
    ) {
      bool = true;
    }
  }

  return bool;
};

export const removeTags = (str: string) => {
  if (str === null || str === "") return "";
  else str = str.toString();

  // Regular expression to identify HTML tags in
  // the input string. Replacing the identified
  // HTML tag with a null string.
  return str.replace(/(<([^>]+)>)/gi, "");
};

export const redirectTo = (path: string) => {
  return (window.location.href = path);
};

export const getRandom = (min: number, max: number) => {
  return parseInt((Math.random() * (max - min) + min).toString());
};

export const isReservationPaid = (reservation: CustomerBooking) => {
  let paid = true;
  reservation?.stays?.forEach((s) => {
    s?.occupants?.forEach((o) => {
      o?.paymentDues?.forEach((p) => {
        if (p?.remainingAmount?.amount > 0) {
          paid = false;
        }
      });
    });
  });
  return paid;
};

export const convertSuggestionToStreetname = (suggestion: any) => {
  let streetname = suggestion.place_name;

  if (suggestion && suggestion !== null) {
    if (!isEmpty(suggestion.address)) {
      streetname = `${suggestion.address} `;
    }

    if (!isEmpty(suggestion.text)) {
      streetname += suggestion.text;
    }

    return streetname;
  }
};

export const getAllLineItems = (cart: Cart | null) => {
  let lineitems: Maybe<Lineitem>[] = [];
  //On récupere les lineitems du panier par défaut (déjà réglé du coup)
  cart?.reservations?.forEach((resa) => {
    resa?.stays?.forEach((stay) => {
      stay?.occupants?.forEach((occupant) => {
        if (occupant && occupant?.lineItems) {
          lineitems?.push(...occupant?.lineItems);
        }
      });
    });
  });

  return lineitems;
};

export const getAllLineItemsWithoutTaxes = (cart: Cart | null) => {
  let lineitems: Maybe<Lineitem>[] = [];
  //On récupere les lineitems du panier par défaut (déjà réglé du coup)

  cart?.reservations?.forEach((resa) => {
    resa?.stays?.forEach((stay) => {
      stay?.occupants?.forEach((occupant) => {
        if (occupant && occupant?.lineItems) {
          lineitems?.push(
            ...occupant?.lineItems?.filter(
              (x) => !TAXES_PRODUCTS.includes(x?.product?.code!!)
            )
          );
        }
      });
    });
  });

  return lineitems;
};

export const getAllLineItemsTaxe = (cart: Cart | null) => {
  let lineitems: Maybe<Lineitem>[] = [];
  //On récupere les lineitems taxe du panier par défaut (déjà réglé du coup)

  cart?.reservations?.forEach((resa) => {
    resa?.stays?.forEach((stay) => {
      stay?.occupants?.forEach((occupant) => {
        if (occupant && occupant?.lineItems) {
          lineitems?.push(
            ...occupant?.lineItems?.filter((x) =>
              TAXES_PRODUCTS.includes(x?.product?.code!!)
            )
          );
        }
      });
    });
  });

  return lineitems;
};

export const getTotalTax = (cart: Cart | null) => {
  let totalTax = 0;
  for (let i = 0; i < (cart?.reservations?.length ?? -1); i++) {
    const currentReservation = cart?.reservations?.[i];
    if (currentReservation) {
      for (let j = 0; j < (currentReservation.stays?.length ?? -1); j++) {
        const currentStay = currentReservation?.stays?.[j];
        if (currentStay) {
          for (let k = 0; k < (currentStay.occupants?.length ?? -1); k++) {
            const currentOccupant = currentStay?.occupants?.[k];
            if (currentOccupant) {
              const occupantLineItems = currentOccupant?.lineItems;
              if (occupantLineItems && occupantLineItems.length > 0) {
                for (let l = 0; l < (occupantLineItems.length ?? -1); l++) {
                  const lineitem = occupantLineItems[l];
                  if (lineitem) {
                    if (TAXES_PRODUCTS.includes(lineitem.product?.code ?? "")) {
                      totalTax += lineitem.totalAmount?.amount;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  return totalTax;
};

export const getFormuleSejour = (cart: Cart | null) => {
  let formule = "";
  cart?.reservations?.[0]?.stays?.forEach((s) => {
    s?.occupants?.forEach((o, i) => {
      //on tape sur 1er occupant
      if (i === 0) {
        o?.lineItems?.forEach((l) => {
          if (l?.product?.isBase) {
            formule = l.label ?? "";
          }
        });
      }
    });
  });

  return formule;
};

export const getBaseLineItem = (
  cart: Cart | null,
  stayGuiid: number
): Lineitem | null => {
  let x = cart?.reservations?.[0]?.stays?.find((s) => s?.guiid === stayGuiid);
  let baseLineItem = null;
  if (x) {
    x.occupants?.forEach((o) => {
      o?.lineItems?.forEach((l) => {
        if (l?.product?.isBase) {
          baseLineItem = l;
        }
      });
    });
  }

  return baseLineItem;
};

export const getTotalPaid = (cart: Cart | null) => {
  let amount = 0;
  cart?.reservations?.forEach((resa) => {
    resa?.stays?.forEach((stay) => {
      stay?.occupants?.forEach((occupant) => {
        occupant?.paymentDues?.forEach((payment) => {
          amount += payment?.receivedAmount?.amount ?? 0;
        });
      });
    });
  });

  return amount;
};

export const getTotalRemaining = (cart: Cart | null) => {
  let amount = 0;
  cart?.reservations?.forEach((resa) => {
    resa?.stays?.forEach((stay) => {
      stay?.occupants?.forEach((occupant) => {
        occupant?.paymentDues?.forEach((payment) => {
          amount += payment?.remainingAmount?.amount ?? 0;
        });
      });
    });
  });

  return amount;
};

export const getTotalRemainingIncludingPrereserved = (cart: Cart | null) => {
  let amount = 0;
  cart?.reservations?.forEach((resa) => {
    resa?.stays?.forEach((stay) => {
      stay?.occupants?.forEach((occupant) => {
        occupant?.paymentDues?.forEach((payment) => {
          amount += payment?.remainingAmount?.amount ?? 0;
        });
        occupant?.lineItems?.forEach((lineitem) => {
          if (lineitem?.preReserved === true) {
            amount += lineitem?.product?.price?.amount ?? 0;
          }
        });
      });
    });
  });

  return amount;
};

export const getCustomerUrlByWebUser = (webUser: string, mode: ConfigMode) => {
  let url = process.env.REACT_APP_CUSTOMER_URL;
  if (mode === "corseole") {
    url = process.env.REACT_APP_CUSTOMER_URL_CORSEOLE;
  } else {
    if (webUser === "web_fr_b2b") {
      url = process.env.REACT_APP_CUSTOMER_URL;
    } else if (webUser === "webEN" || webUser === "web_en_b2b") {
      url = process.env.REACT_APP_CUSTOMER_URL_EN
        ? process.env.REACT_APP_CUSTOMER_URL_EN
        : `${process.env.REACT_APP_CUSTOMER_URL}/en`;
    }
  }

  return url;
};
